/**
 * Created by ru on 2022/2/23
 */
import React, { Component } from "react";
import { Image, Modal, StyleSheet, TouchableOpacity, View } from "react-native";
import { Body, Button, Container, Left, Right, Title } from "native-base";
import Header from "./WrappedHeader";
import Icon from "react-native-vector-icons/Ionicons";
import ImageSize from "react-native-image-size";
import ImageZoom from "react-native-image-pan-zoom";

import UIDs from "../../UIDs";
import { withTranslation } from "react-i18next";

import Dimensions from "react-native-web-dimension-helper";

const uid = UIDs.components.ui.zoomerImage;

class ZoomerImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orientation: "PORTRAIT",
            imgWidth: 0,
            imgHeight: 0,
            modalVisible: false,
        };

        if (props.source && props.source.uri) {
            ImageSize.getSize(props.source.uri).then(({ width, height }) => {
                this.setState({ imgWidth: width, imgHeight: height });
            });
        }
    }

    componentDidMount() {}

    componentWillUnmount() {}

    _setupImageZoom = ref => {
        this._imageZoom = ref;
        // this.zoomImage(0, 2);
    };

    _onOrientationDidChange = orientation => {
        this.setState({ orientation: orientation });
    };

    onShowModal = () => {
        this.setState({ modalVisible: true });
        //this.zoomImage(0, 2);
    };

    onHideModal = () => {
        this.setState({ modalVisible: false });
    };

    isLandscape = () => {
        return this.state.orientation.indexOf("LANDSCAPE") >= 0;
    };

    zoomImage = (factor, toscale) => {
        if (this._imageZoom) {
            var windowWidth = Dimensions.get("window").width;
            var windowHeight = Dimensions.get("window").height;
            if (this.isLandscape()) {
                windowHeight -= 20;
            } else {
                windowHeight -= 40;
            }

            var scale = toscale ? toscale : this._imageZoom.scale * factor;
            if (scale < this._imageZoom.props.minScale) {
                scale = this._imageZoom.props.minScale;
            } else if (scale > this._imageZoom.props.maxScale) {
                scale = this._imageZoom.props.maxScale;
            }
            this._imageZoom.centerOn({ x: 0, y: 0, scale: scale });
        }
    };

    onZoomIn = () => {
        this.zoomImage(1.5);
    };

    onZoomOut = () => {
        this.zoomImage(0.7);
    };

    renderHeader() {
        if (this.isLandscape()) {
            return (
                <View style={{ zIndex: 10, position: "absolute", left: 20, top: 8 }}>
                    <Button transparent onPress={() => this.onHideModal()}>
                        <Icon name="ios-arrow-back" style={[styles.headerIcon]} />
                    </Button>
                </View>
            );
        }
        return (
            <Header style={[styles.headerColor]}>
                <Left style={[styles.flex1]}>
                    <Button transparent onPress={() => this.onHideModal()}>
                        <Icon name="ios-arrow-back" style={[styles.headerIcon]} />
                    </Button>
                </Left>
                <Body style={[styles.flex3, styles.alignItemsCenter]}>
                    <Title style={[styles.headerTitle]}>{this.props.t("imagePreview")}</Title>
                </Body>
                <Right style={[styles.flex1]} />
            </Header>
        );
    }

    render() {
        var windowWidth = Dimensions.get("window").width;
        var windowHeight = Dimensions.get("window").height;
        if (this.state.orientation.indexOf("LANDSCAPE") >= 0) {
            windowHeight -= 20;
        } else {
            windowHeight -= 40;
        }
        var imageWidth = this.state.imgWidth;
        var imageHeight = this.state.imgHeight;
        if (this.state.imgWidth > 0 && this.state.imgHeight > 0) {
            var ratioWidth = windowWidth / this.state.imgWidth;
            var ratioHeight = windowHeight / this.state.imgHeight;
            if (ratioWidth < ratioHeight) {
                imageWidth *= ratioWidth;
                imageHeight *= ratioWidth;
            } else {
                imageWidth *= ratioHeight;
                imageHeight *= ratioHeight;
            }
        }
        return (
            <View>
                <TouchableOpacity onPress={() => this.onShowModal()}>
                    <View>
                        <Image style={this.props.style} source={this.props.source} resizeMode={this.props.resizeMode} />
                        {/*<FAIcon name="search-plus"
                                style={{zIndex: 1, position: 'absolute', right: 8,
                                        top: (imageHeight > 40 ? 8 : 0),
                                        fontSize: (imageHeight > 40 ? 24 : 20),
                                        color: "#fdaf2c"}}/>*/}
                        <Icon
                            name="ios-add-circle-outline"
                            style={{ zIndex: 1, position: "absolute", right: 8, top: imageHeight > 40 ? 8 : 0, fontSize: imageHeight > 40 ? 24 : 20, color: "#fdaf2c" }}
                        />
                    </View>
                </TouchableOpacity>
                <Modal
                    visible={this.state.modalVisible}
                    transparent={true}
                    presentationStyle="overFullScreen"
                    supportedOrientations={["portrait", "portrait-upside-down", "landscape", "landscape-left", "landscape-right"]}
                    onRequestClose={() => this.onHideModal()}>
                    <Container>
                        {this.renderHeader()}
                        <View style={[styles.centerAlign]}>
                            {/*<TouchableOpacity style={{ zIndex: 1, position: "absolute", right: 20, top: 20 }} onPress={() => this.onZoomIn()}>
                                <FAIcon name="search-plus"
                                   style={{fontSize: 30, color: "#fdaf2c"}}/>
                                <Icon name="ios-add-circle-outline" style={{ fontSize: 30, color: "#fdaf2c" }} />
                            </TouchableOpacity>
                            <TouchableOpacity style={{ zIndex: 1, position: "absolute", right: 20, top: 60 }} onPress={() => this.onZoomOut()}>
                                <FAIcon name="search-minus"
                                   style={{fontSize: 30, color: "#fdaf2c"}}/>
                                <Icon name="ios-remove-circle-outline" style={{ fontSize: 30, color: "#fdaf2c" }} />
                            </TouchableOpacity>*/}
                            <ImageZoom
                                key={this.state.orientation}
                                // ref={this._setupImageZoom}
                                cropWidth={windowWidth}
                                cropHeight={windowHeight}
                                imageWidth={imageWidth}
                                imageHeight={imageHeight}
                                enableSwipeDown={false}
                                onClick={() => this.onHideModal()}>
                                <Image
                                    key={this.state.orientation}
                                    enableHorizontalBounce={true}
                                    style={{
                                        width: imageWidth,
                                        height: imageHeight,
                                    }}
                                    source={this.props.source}
                                />
                            </ImageZoom>
                        </View>
                    </Container>
                </Modal>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    centerAlign: {
        justifyContent: "center",
        alignItems: "center",
    },

    headerColor: {
        backgroundColor: "#fff",
    },

    headerTitle: {
        color: "#111",
    },

    flex1: {
        flex: 1,
    },

    flex3: {
        flex: 3,
    },

    alignItemsCenter: {
        alignItems: "center",
    },

    headerIcon: {
        fontSize: 30,
        color: "#777",
    },

    marginHorizontal16: {
        marginHorizontal: 16,
    },

    marginVertical16: {
        marginVertical: 16,
    },
});

export default withTranslation(uid, { withRef: true })(ZoomerImage);
